import React from 'react'
import { Text } from '@lightspeed/design-system-react'
import { vn, add } from 'vend-number'

import { T } from '@transifex/react'
import { RoundedNumber } from '../../CashPaymentModal'
import { useFormatCurrencyValue } from '../../../../sale/summary-panel/useFormatCurrencyValue'

interface HeaderProps {
  amountToPay: RoundedNumber
}

const RoundedMessage: React.FC<HeaderProps> = ({ amountToPay }) => {
  const formatCurrencyValue = useFormatCurrencyValue()
  const roundedAmountToPay = vn(amountToPay.rounded)
  const originalAmountToPay = add(amountToPay.remainder, roundedAmountToPay)

  if (roundedAmountToPay.gt(originalAmountToPay)) {
    return (
      <T
        _str="Rounded up from {originalAmount}"
        originalAmount={formatCurrencyValue(originalAmountToPay.toString())}
      />
    )
  }
  return (
    <T
      _str="Rounded down from {originalAmount}"
      originalAmount={formatCurrencyValue(originalAmountToPay.toString())}
    />
  )
}

// Component
export const Header: React.FC<HeaderProps> = ({ amountToPay }) => {
  const formatCurrencyValue = useFormatCurrencyValue()
  const roundedAmountToPay = vn(amountToPay.rounded)
  const originalAmountToPay = add(amountToPay.remainder, roundedAmountToPay)

  return (
    <div className="payment-cash-modal-header">
      <div className="payment-cash-modal-header-headline">
        <T _str="Amount to pay" />
      </div>
      <div className="payment-cash-modal-header-balance">
        {formatCurrencyValue(roundedAmountToPay.toString())}
        <Text tag="p">
          {!roundedAmountToPay.eq(originalAmountToPay) && (
            <RoundedMessage amountToPay={amountToPay} />
          )}
        </Text>
      </div>
    </div>
  )
}
